import { Check } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ComponentProps } from "@/types/component-props.type";
import WhatsappLink from "@/helpers/whatsAppHelper";

const FaWhatsappIcon = FaWhatsapp as unknown as React.FC;

const OffersComponent = ({ sectionRef }: ComponentProps) => {
  return (
    <section ref={sectionRef} className="py-12 px-4 custom-bg-color-02">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl font-bold text-center mb-12 custom-color-01">
          Condições especiais para sua participação e da sua igreja
        </h3>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <Card className="shadow-lg hover:shadow-xl transition-shadow custom-bg-color-01 custom-border-color-04">
            <CardHeader
              className="text-center custom-bg-color-04 custom-color-01"
              style={{ borderRadius: "5px 5px 0px 0px" }}
            >
              <CardTitle className="text-2xl">Modalidade Presencial</CardTitle>
              <CardDescription className="text-3xl font-bold">
                R$ 119,90
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6">
              <ul className="space-y-3 custom-color-03 ">
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Treinamento intensivo de um dia com especialistas</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Certificado oficial de participação</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Coffee break e networking</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Material de apoio físico exclusivo</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Acesso a todas as 10 palestras presenciais</span>
                </li>
                <li className="flex items-start gap-3">
                  <Badge
                    variant="secondary"
                    className="custom-bg-color-04 custom-color-01"
                  >
                    Bônus
                  </Badge>
                  <span>
                    Curso breve de Aconselhamento Bíblico (12 aulas gravadas +
                    material didático + 3 aulas tira dúvidas)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Badge
                    variant="secondary"
                    className="custom-bg-color-04 custom-color-01"
                  >
                    Bônus
                  </Badge>
                  <span>
                    Acesso por 6 meses às palestras do congresso gravadas
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Badge
                    variant="secondary"
                    className="custom-bg-color-04 custom-color-01"
                  >
                    Bônus
                  </Badge>
                  <span>Certificado do curso de Aconselhamento Bíblico</span>
                </li>
              </ul>
              <a
                href="https://www.sympla.com.br/evento/4-congresso-de-aconselhamento-bIblico-vida-e-piedade-2025/3029240 "
                target="_blank"
                rel="noreferrer"
              >
                <Button className="w-full mt-6 text-white font-semibold cursor-pointer custom-bg-color-04 custom-color-01">
                  Escolher Presencial
                </Button>
              </a>
            </CardContent>
          </Card>
          <Card className="shadow-lg hover:shadow-xl transition-shadow custom-bg-color-01 custom-border-color-03">
            <CardHeader
              className="text-center custom-bg-color-03 custom-color-01"
              style={{ borderRadius: "5px 5px 0px 0px" }}
            >
              <CardTitle className="text-2xl">Modalidade Online</CardTitle>
              <CardDescription className="text-3xl font-bold">
                R$ 59,90
              </CardDescription>
            </CardHeader>
            <CardContent className="p-6 flex flex-col justify-around">
              <ul className="space-y-3 custom-color-03">
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Acesso digital a todas as 10 palestras</span>
                </li>
                <li className="flex items-start gap-3">
                  <Check className="w-5 h-5 mt-1 flex-shrink-0 custom-color-02" />
                  <span>Certificado oficial de participação</span>
                </li>
                <li className="flex items-start gap-3">
                  <Badge
                    variant="secondary"
                    className="custom-bg-color-04 custom-color-01"
                  >
                    Bônus
                  </Badge>
                  <span>
                    Curso breve de Aconselhamento Bíblico (12 aulas gravadas +
                    material didático + 3 aulas tira dúvidas)
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Badge
                    variant="secondary"
                    className="custom-bg-color-04 custom-color-01"
                  >
                    Bônus
                  </Badge>
                  <span>
                    Acesso por 6 meses às palestras do congresso gravadas
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <Badge
                    variant="secondary"
                    className="custom-bg-color-04 custom-color-01"
                  >
                    Bônus
                  </Badge>
                  <span>Certificado do curso de Aconselhamento Bíblico</span>
                </li>
              </ul>
              <a
                href="https://www.sympla.com.br/evento-online/4-congresso-online-de-aconselhamento-bIblico-vida-e-piedade-2025/3032636"
                target="_blank"
                rel="noreferrer"
              >
                <Button className="w-full mt-6 text-white font-semibold cursor-pointer custom-bg-color-03">
                  Escolher Online
                </Button>
              </a>
            </CardContent>
          </Card>
        </div>

        <div className="rounded-2xl p-8 mb-8 custom-bg-color-linear-gradient-color-04-to-color-02">
          <h4 className="text-2xl font-bold text-center mb-6 custom-color-01">
            Ofertas para Grupos e Igrejas
          </h4>

          <div className="grid md:grid-cols-1 gap-6 max-w-[400px] mx-auto">
            <Card className="custom-bg-color-01 custom-border-color-04 custom-color-03">
              <CardHeader className="text-center">
                <CardTitle className="text-lg custom-color-04 ">
                   Descontos especiais <br />para grupos de 5 e 10 pessoas
                </CardTitle>
              </CardHeader>
              <CardContent className="text-center">
                <CardDescription>Confira no ato da inscrição</CardDescription>
                <p className="text-sm mt-3 custom-color-02">
                  Faça contato pelo WhatsApp e saiba mais
                </p>
                <div>
                  <a href={WhatsappLink} target="_blank" rel="noreferrer">
                    <Button className="w-full mt-6 text-white font-semibold cursor-pointer custom-bg-color-04 custom-color-01">
                      Eu Quero{" "}<FaWhatsappIcon />
                    </Button>
                  </a>
                </div>
              </CardContent>
            </Card>

            {/* <Card className="custom-bg-color-01 custom-border-color-03 custom-color-03">
              <CardHeader className="text-center">
                <CardTitle className="text-lg">Oferta Exclusiva</CardTitle>
                <CardDescription>Igrejas Grande BH</CardDescription>
              </CardHeader>
              <CardContent className="text-center">
                <p className="text-2xl font-bold mb-2">10% desconto</p>
                <Badge className="text-white custom-bg-color-04">
                  + Workshop na igreja
                </Badge>
                <div>
                  <Button
                    className="w-full mt-6 text-white font-semibold cursor-pointer custom-bg-color-03"
                    style={{
                      backgroundColor: "#ccc",
                      color: "#898787d7",
                      cursor: "not-allowed",
                    }}
                  >
                    Eu Quero
                  </Button>
                </div>
              </CardContent>
            </Card> */}
          </div>
        </div>
      </div>
    </section>
  );
};
export default OffersComponent;
